import type { JSX } from 'react'

export const BundleCover8 = (): JSX.Element => (
  <svg
    width='100%'
    height='100%'
    viewBox='0 0 1920 1080'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    preserveAspectRatio='none'
  >
    <g clipPath='url(#clip0_628_267)'>
      <rect width='1920' height='1080' fill='#161616' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1545.54 0C1520.55 16.1641 1495.42 32.793 1470.18 49.8203C1276.56 180.449 1081.72 331.129 906.437 468.332C888.021 482.748 869.789 497.041 851.771 511.166C700.088 630.08 563.651 737.041 462.24 803.531C407.965 839.117 352.729 870.758 306.312 880.893C283.579 885.857 243.502 890.049 207.804 864.357C169.536 836.816 162.5 794.553 162.5 767.5C162.5 707.975 187.203 644.664 218.847 585.643C251.574 524.602 297.041 458.586 349.416 391.229C426.572 292.002 521.736 186.045 620.524 83.4941C513.87 143.918 406.638 202.199 307.871 252.082C192.812 310.193 84.1182 359.594 0 386.285V216.777C63.3574 192.584 143.867 155.664 235.739 109.262C301.261 76.1699 370.937 39.1074 441.952 0H930.897C901.062 28.6758 870.766 58.2207 840.42 88.3418C707.144 220.625 574.497 362.418 475.725 489.443C426.279 553.031 386.712 611.16 359.858 661.246C354.886 670.52 350.5 679.246 346.649 687.436C355.209 682.186 364.487 676.299 374.511 669.729C469.82 607.236 600.374 504.912 754.081 384.441L754.116 384.412C771.718 370.615 789.623 356.582 807.814 342.342C947.884 232.699 1103.05 112.383 1261.23 0H1545.54ZM0 114.73C21.75 78.2227 46.8838 39.4473 73.8945 0H0V114.73Z'
        fill='url(#paint0_linear_628_267)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1920 273.18V88.4922C1736.53 188.729 1397.88 422.805 1047.36 675.438C861.875 809.123 671.319 949.297 495.741 1080H764.437C888.129 988.725 1015.7 895.482 1140.91 805.238C1448.67 583.428 1737.47 383.191 1920 273.18ZM982.736 1080C1103.5 986.639 1240.34 885.816 1375.49 788.666C1579.17 642.26 1780.99 502.766 1920 408.648V602.234C1792.55 689.518 1631.91 801.395 1468.88 918.584C1457.86 926.51 1446.83 934.455 1435.8 942.416C1420.92 953.156 1406.05 963.922 1391.21 974.699C1553.91 875.842 1733.22 770.586 1920 669.318V851.764C1782.99 927.637 1650.48 1005.16 1526.27 1080H982.736Z'
        fill='url(#paint1_linear_628_267)'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_628_267'
        x1='772.769'
        y1='0'
        x2='772.769'
        y2='884.622'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#0D0F39' />
        <stop offset='1' stopColor='#3D1059' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_628_267'
        x1='1207.87'
        y1='88.4922'
        x2='1207.87'
        y2='1080'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#14165D' />
        <stop offset='1' stopColor='#500E78' />
      </linearGradient>
      <clipPath id='clip0_628_267'>
        <rect width='1920' height='1080' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
